// extracted by mini-css-extract-plugin
export var borderRadius = "_4t-4";
export var large = "_4t-3";
export var logoContainer = "_4t-0";
export var nameLogo = "_4t-2";
export var small = "_4t-1";